import { getURLParam, handlise } from '../helpers/urlHelpers';
// Create a list of all vaid url params
export const getPossibleParams = (components, prefix) => {
    const possibleParams = [];
    components.forEach((component) => {
        component.products.forEach((product) => {
            if (product.inner_parts) {
                product.inner_parts.products.forEach((innerProduct) => {
                    possibleParams.push(`${prefix}${component.name}--${product.part_type}--${innerProduct.part_type}`);
                });
            }
            else {
                possibleParams.push(`${prefix}${component.name}--${product.part_type}`);
            }
        });
    });
    return possibleParams;
};
// Get all available variants for a component
export const extractVariants = (componentData) => {
    const allVariants = [];
    function extractFromComponent(products) {
        products.forEach((product) => {
            if (product.variants && product.variants.length > 1) {
                return allVariants.push(product.variants);
            }
            if (product.inner_parts) {
                return extractFromComponent(product.inner_parts.products);
            }
        });
    }
    componentData.forEach((component) => {
        extractFromComponent(component.products);
    });
    return allVariants;
};
// Get all images from the bundle
export const extractImages = (bundle, components, productHandle) => {
    const allVariants = [];
    function extractFromComponent(component, products) {
        const currentComp = bundle[component];
        if (currentComp) {
            products.forEach((product) => {
                const currentProduct = currentComp.find((prod) => prod.part == product.part_type);
                const monogramming = product.monogramming;
                let emoji = null;
                if (monogramming && monogramming.emojis) {
                    emoji = monogramming.emojis.find((emoji) => emoji.selected);
                }
                const monogramming_back = product.monogramming_back;
                let emoji_back = null;
                if (monogramming_back && monogramming_back.emojis) {
                    emoji_back = monogramming_back.emojis.find((emoji) => emoji.selected);
                }
                if (product.inner_parts) {
                    return extractFromComponent(component, product.inner_parts.products);
                }
                else if (product.variants) {
                    product.variants.forEach((variant) => {
                        let selected = false;
                        if (currentProduct && currentProduct.selectedVariant == variant) {
                            selected = true;
                        }
                        allVariants.push(Object.assign(Object.assign({}, variant), { component: product.part_type, selected: selected, monogramming: monogramming.value, monogramming_back: monogramming_back.value, additional_image: monogramming_back.additional_image, emoji: emoji, emoji_back: emoji_back, parentProduct: productHandle }));
                    });
                }
            });
        }
    }
    components.forEach((component) => {
        extractFromComponent(component.name, component.products);
    });
    return allVariants;
};
// Find a selected variants by colour swatch
export const findVariantByColourName = (components, colourName, currentBundle) => {
    const selectedVariants = {};
    components.forEach((component) => {
        selectedVariants[handlise(component.name)] = [];
        const currentProduct = currentBundle[component.name][0].product;
        const featuredProduct = component.products.find((product) => product.part_type == currentProduct || product.part_type == currentBundle[component.name][0].part);
        if (featuredProduct.inner_parts) {
            featuredProduct.inner_parts.products.forEach((innerProduct) => {
                let found = false;
                // Find the selected colour variant
                innerProduct.variants.forEach((innerVariant) => {
                    if (!found && innerVariant.colour_swatch && innerVariant.colour_swatch.name == colourName) {
                        selectedVariants[component.name].push({
                            selectedVariant: innerVariant,
                            product: featuredProduct.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                        found = true;
                    }
                });
                // If it's not found, return the current colour
                if (!found) {
                    if (innerProduct.variants.length == 1) {
                        selectedVariants[component.name].push({
                            selectedVariant: innerProduct.variants[0],
                            product: featuredProduct.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                    }
                    else {
                        const currentBundleProduct = currentBundle[component.name].find((bundleProd) => bundleProd.part == innerProduct.part_type);
                        selectedVariants[component.name].push({
                            selectedVariant: currentBundleProduct.selectedVariant,
                            product: featuredProduct.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                    }
                }
            });
        }
        else {
            let found = false;
            featuredProduct.variants.forEach((innerVariant) => {
                if (!found && innerVariant.colour_swatch && innerVariant.colour_swatch.name == colourName) {
                    selectedVariants[component.name].push({
                        selectedVariant: innerVariant,
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                    });
                    found = true;
                }
            });
            if (!found) {
                if (featuredProduct.variants.length == 1) {
                    selectedVariants[component.name].push({
                        selectedVariant: featuredProduct.variants[0],
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                    });
                }
                else {
                    const currentBundleProduct = currentBundle[component.name].find((bundleProd) => bundleProd.part == featuredProduct.part_type);
                    selectedVariants[component.name].push({
                        selectedVariant: currentBundleProduct.selectedVariant,
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                    });
                }
            }
        }
        if (selectedVariants[component.name].length === 0) {
            selectedVariants[component.name].push(currentBundle[component.name][0]);
        }
    });
    return selectedVariants;
};
// Find common colours for all components
export const findCommonColourSwatches = (variantArrays) => {
    // Find the longest array of variants
    const longestArray = variantArrays.reduce((max, arr) => (arr.length > max.length ? arr : max), []);
    // Extract all colour_swatch objects from the longest array as the initial set
    let commonColourSwatches = longestArray.filter((variant) => variant.colour_swatch !== null && variant.colour_swatch.exclude_in_solid_colours != true).map((variant) => (Object.assign(Object.assign({}, variant.colour_swatch), { available: variant.available })));
    // Compare with the rest of the arrays
    for (const variants of variantArrays) {
        if (variants.length > 1 && variants !== longestArray) {
            const currentColourSwatches = variants.filter((variant) => variant.colour_swatch !== null && variant.colour_swatch.exclude_in_solid_colours != true).map((variant) => (Object.assign(Object.assign({}, variant.colour_swatch), { available: variant.available })));
            if (currentColourSwatches.length > 0) {
                commonColourSwatches = commonColourSwatches.filter((colourSwatch) => currentColourSwatches.some((currentColourSwatch) => currentColourSwatch.name === colourSwatch.name));
                commonColourSwatches = commonColourSwatches.map((colourSwatch) => {
                    const currentSwatch = currentColourSwatches.find((swatch) => swatch.name == colourSwatch.name);
                    if (currentSwatch.available == false) {
                        return currentSwatch;
                    }
                    else {
                        return colourSwatch;
                    }
                });
            }
        }
    }
    return commonColourSwatches;
};
// Find all colours for all components
export const findAllColourSwatches = (variantArrays) => {
    const colourSwatches = new Map();
    variantArrays.forEach((group) => {
        group.forEach((item) => {
            const swatch = item.colour_swatch;
            swatch['available'] = item.available;
            if (swatch) {
                const colorKey = swatch.color || swatch.name;
                if (!colourSwatches.has(colorKey)) {
                    colourSwatches.set(colorKey, swatch);
                }
            }
        });
    });
    return Array.from(colourSwatches.values());
};
// Find first available variant in a component
export const findFirstAvailableVariants = (components) => {
    const selectedVariants = {};
    components.forEach((component) => {
        selectedVariants[handlise(component.name)] = [];
        const featuredProduct = component.products[0];
        if (featuredProduct.inner_parts) {
            featuredProduct.inner_parts.products.forEach((innerProduct) => {
                let found = false;
                innerProduct.variants.forEach((innerVariant) => {
                    if (!found && innerVariant.available) {
                        selectedVariants[component.name].push({
                            selectedVariant: innerVariant,
                            product: featuredProduct.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                        found = true;
                    }
                });
                if (!found) {
                    const selectedVariant = innerProduct.variants[0];
                    selectedVariants[component.name].push({
                        selectedVariant: selectedVariant,
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: innerProduct.part_type,
                        otherVariants: innerProduct.variants,
                        title: innerProduct.title,
                        monogramming: innerProduct.monogramming,
                        monogramming_back: innerProduct.monogramming_back,
                    });
                }
            });
        }
        else {
            let found = false;
            featuredProduct.variants.forEach((innerVariant) => {
                if (!found && innerVariant.available) {
                    selectedVariants[component.name].push({
                        selectedVariant: innerVariant,
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                    });
                    found = true;
                }
            });
            if (!found) {
                selectedVariants[component.name].push({
                    selectedVariant: featuredProduct.variants[0],
                    product: featuredProduct.part_type,
                    component: component.name,
                    part: featuredProduct.part_type,
                    otherVariants: featuredProduct.variants,
                    title: featuredProduct.title,
                    monogramming: featuredProduct.monogramming,
                    monogramming_back: featuredProduct.monogramming_back,
                });
            }
        }
        if (selectedVariants[component.name].length === 0) {
            delete selectedVariants[component.name];
        }
    });
    return selectedVariants;
};
// Find selected variant in a component  by default parts
export const findSelectedVariants = (components, defaultParts) => {
    const selectedVariants = {};
    const defaultGroups = defaultParts.filter((dp) => dp.part_type.includes('base') || dp.part_type.includes('hull'));
    const otherDefaultParts = defaultParts.filter((dp) => dp.part_type.includes('base') == false && dp.part_type.includes('hull') == false);
    defaultGroups.forEach((defaultPart) => {
        const selectedType = defaultPart.part_type;
        const selectedComponent = components.find((component) => {
            return component.products.find((product) => { var _a; return product.part_type == selectedType || ((_a = product.inner_parts) === null || _a === void 0 ? void 0 : _a.products.some((innerPart) => innerPart.part_type == selectedType)); });
        });
        const selectedProduct = selectedComponent.products.find((part) => { var _a; return part.part_type == selectedType || ((_a = part.inner_parts) === null || _a === void 0 ? void 0 : _a.products.some((innerPart) => innerPart.part_type == selectedType)); });
        if (selectedProduct) {
            selectedVariants[selectedComponent.name] = [];
            if (selectedProduct.inner_parts) {
                const selectedPart = selectedProduct.inner_parts.products.find((elem) => elem.part_type === selectedType);
                const selectedVariant = selectedPart.variants.find((elem) => elem.id === defaultPart.id);
                selectedVariants[selectedComponent.name].push({
                    selectedVariant: selectedVariant,
                    product: selectedProduct.part_type,
                    component: selectedComponent.name,
                    part: selectedPart.part_type,
                    otherVariants: selectedPart.variants,
                    title: selectedProduct.title,
                    monogramming: selectedProduct.monogramming,
                    monogramming_back: selectedProduct.monogramming_back,
                });
                if (otherDefaultParts.length < defaultGroups.length) {
                    otherDefaultParts.forEach((otherDefaultPart) => {
                        const otherSelectedType = otherDefaultPart.part_type;
                        const otherSelectedPart = selectedProduct.inner_parts.products.find((elem) => elem.part_type === otherSelectedType);
                        if (otherSelectedPart) {
                            const otherSelectedVariant = otherSelectedPart.variants.find((elem) => elem.id === otherDefaultPart.id);
                            selectedVariants[selectedComponent.name].push({
                                selectedVariant: otherSelectedVariant,
                                product: selectedProduct.part_type,
                                component: selectedComponent.name,
                                part: otherSelectedPart.part_type,
                                otherVariants: otherSelectedPart.variants,
                                title: otherSelectedPart.title,
                                monogramming: otherSelectedPart.monogramming,
                                monogramming_back: otherSelectedPart.monogramming_back,
                            });
                        }
                    });
                }
                if (selectedProduct.inner_parts.products.length > selectedVariants[selectedComponent.name].length) {
                    const missingParts = selectedProduct.inner_parts.products.filter((elem) => !selectedVariants[selectedComponent.name].find((inner) => inner.part == elem.part_type));
                    missingParts.forEach((missingPart) => {
                        const availableVariant = missingPart.variants.find((elem) => elem.available) || missingPart.variants[0];
                        selectedVariants[selectedComponent.name].push({
                            selectedVariant: availableVariant,
                            product: selectedProduct.part_type,
                            component: selectedComponent.name,
                            part: missingPart.part_type,
                            otherVariants: missingPart.variants,
                            title: missingPart.title,
                            monogramming: selectedProduct.monogramming,
                            monogramming_back: selectedProduct.monogramming_back,
                        });
                    });
                }
            }
            else {
                const selectedVariant = selectedProduct.variants.find((elem) => elem.id === defaultPart.id);
                selectedVariants[selectedComponent.name].push({
                    selectedVariant: selectedVariant,
                    product: selectedProduct.part_type,
                    component: selectedComponent.name,
                    part: selectedProduct.part_type,
                    otherVariants: selectedProduct.variants,
                    title: selectedProduct.title,
                    monogramming: selectedProduct.monogramming,
                    monogramming_back: selectedProduct.monogramming_back,
                });
            }
        }
    });
    return selectedVariants;
};
// Find variants from URL params
export const getVariantsFromURL = (queryParams, components, prodIndex) => {
    const variants = {};
    // Loop through each component
    components.forEach((component) => {
        // Initialize the component array in the result object
        if (!variants[component.name]) {
            variants[component.name] = [];
        }
        component.products.forEach((product) => {
            // Check if the product has inner parts or variants directly
            if (product.inner_parts) {
                product.inner_parts.products.forEach((innerProduct) => {
                    const paramName = `${prodIndex + 1}--${component.name}--${product.part_type}--${innerProduct.part_type}`;
                    const paramId = queryParams.get(paramName);
                    // Check if that paramName is in the URL
                    if (paramId) {
                        let foundVariant = null;
                        // Check if that variant exists
                        innerProduct.variants.forEach((variant) => {
                            if (String(variant.id) === paramId) {
                                foundVariant = variant;
                            }
                        });
                        // If not, replace it with the first available
                        if (!foundVariant) {
                            foundVariant = innerProduct.variants.find((variant) => variant.available) || innerProduct.variants[0];
                        }
                        variants[component.name].push({
                            selectedVariant: foundVariant,
                            product: product.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                    }
                });
            }
            else {
                // Does not have inner parts
                const paramName = `${prodIndex + 1}--${component.name}--${product.part_type}`;
                const paramId = queryParams.get(paramName);
                const preselectedVariant = queryParams.get('variant');
                if (paramId || preselectedVariant) {
                    let foundVariant = null;
                    product.variants.forEach((variant) => {
                        // Check if that variant exists
                        if (String(variant.id) === paramId || String(variant.id) === preselectedVariant) {
                            foundVariant = variant;
                        }
                    });
                    // If not, replace it with the first available
                    if (!foundVariant) {
                        foundVariant = product.variants.find((variant) => variant.available) || product.variants[0];
                    }
                    variants[component.name].push({
                        selectedVariant: foundVariant,
                        product: product.part_type,
                        component: component.name,
                        part: product.part_type,
                        otherVariants: product.variants,
                        title: product.title,
                        monogramming: product.monogramming,
                        monogramming_back: product.monogramming_back,
                    });
                }
            }
        });
    });
    // Check if the component is missing elements
    for (const component in variants) {
        if (variants[component].length) {
            const compName = variants[component][0].component;
            const prodName = variants[component][0].product;
            const partName = variants[component][0].part;
            // Find the current component
            const productOptions = components.find((innerComp) => innerComp.name == compName);
            // If the component has different product options, find the current product
            if (productOptions && productOptions.products.length == 1 && productOptions.base_component == true) {
                const paramName = `${prodIndex + 1}--${compName}--${prodName}`;
                const paramId = queryParams.get(paramName);
                const preselectedVariant = queryParams.get('variant');
                if (!paramId && !preselectedVariant) {
                    const firstAvailable = productOptions.products[0].variants.find((variant) => variant.available) || productOptions.products[0].variants[0];
                    variants[component].push({
                        selectedVariant: firstAvailable,
                        product: prodName,
                        component: compName,
                        part: productOptions.products[0].part_type,
                        otherVariants: productOptions.products[0].variants,
                        title: productOptions.products[0].title,
                        monogramming: productOptions.products[0].monogramming,
                        monogramming_back: productOptions.products[0].monogramming_back,
                    });
                }
            }
            else if (productOptions) {
                const innerProductOptions = productOptions.products.find((innerProd) => innerProd.part_type == prodName || innerProd.part_type == partName);
                if (innerProductOptions.inner_parts) {
                    innerProductOptions.inner_parts.products.forEach((innerPart) => {
                        const paramName = `${prodIndex + 1}--${component}--${prodName}--${innerPart.part_type}`;
                        const paramId = getURLParam(paramName);
                        if (!paramId) {
                            const firstAvailable = innerPart.variants.find((variant) => variant.available) || innerPart.variants[0];
                            variants[component].push({
                                selectedVariant: firstAvailable,
                                product: prodName,
                                component: compName,
                                part: innerPart.part_type,
                                otherVariants: innerPart.variants,
                                title: innerPart.title,
                                monogramming: innerPart.monogramming,
                                monogramming_back: innerPart.monogramming_back,
                            });
                        }
                    });
                }
            }
        }
        else {
            const productOptions = components.find((innerComp) => innerComp.name == component);
            const featuredProduct = productOptions.products[0];
            if (featuredProduct.inner_parts) {
                featuredProduct.inner_parts.products.forEach((innerProduct) => {
                    let found = false;
                    innerProduct.variants.forEach((innerVariant) => {
                        if (!found && innerVariant.available) {
                            variants[component].push({
                                selectedVariant: innerVariant,
                                product: featuredProduct.part_type,
                                component: component,
                                part: innerProduct.part_type,
                                otherVariants: innerProduct.variants,
                                title: innerProduct.title,
                                monogramming: innerProduct.monogramming,
                                monogramming_back: innerProduct.monogramming_back,
                            });
                            found = true;
                        }
                    });
                    if (!found) {
                        variants[component].push({
                            selectedVariant: innerProduct.variants[0],
                            product: featuredProduct.part_type,
                            component: component,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                    }
                });
            }
            else {
                let found = false;
                featuredProduct.variants.forEach((innerVariant) => {
                    if (!found && innerVariant.available) {
                        variants[component].push({
                            selectedVariant: innerVariant,
                            product: featuredProduct.part_type,
                            component: component,
                            part: featuredProduct.part_type,
                            otherVariants: featuredProduct.variants,
                            title: featuredProduct.title,
                            monogramming: featuredProduct.monogramming,
                            monogramming_back: featuredProduct.monogramming_back,
                        });
                        found = true;
                    }
                });
                if (!found) {
                    variants[component].push({
                        selectedVariant: featuredProduct.variants[0],
                        product: featuredProduct.part_type,
                        component: component,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                    });
                }
            }
        }
    }
    return variants;
};
// Map variants as URL params
export const mapComponentVariants = (currentBundleItems) => {
    const result = {};
    const mapItems = (componentObject, prefix) => {
        for (const component in componentObject) {
            if (Array.isArray(componentObject[component])) {
                if (componentObject[component].length > 1) {
                    componentObject[component].forEach((item) => {
                        const key = `${prefix}${component}--${item.product}--${item.part}`;
                        result[key] = item.selectedVariant.id;
                    });
                }
                else {
                    componentObject[component].forEach((item) => {
                        const key = `${prefix}${component}--${item.part}`;
                        result[key] = item.selectedVariant.id;
                    });
                }
            }
        }
    };
    currentBundleItems.forEach((bundleProd, index) => {
        mapItems(bundleProd, `${index + 1}--`);
    });
    return result;
};
export const convertToTitleCase = (str) => {
    return str
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
